export default __webpack_public_path__ + "static/media/icon-location.e3dac6a1.svg";